import DOMPurify from 'dompurify';
import {SecUtilHasRoles} from '@/types/common/utils/SecUtilInterfaces';
import {useStore} from '@/common/store/store';

/** A feature module of the coaching, as the store tracks it (store.coaching). */
export type CoachingModule = keyof ReturnType<typeof useStore>['coaching'];

export class SecUtil {

  public static hasRoles(roles: string): boolean {
    const store = useStore();
    let access = false;
    if (store.roles.length === 0) {
      return access;
    }

    if (roles.constructor === String) {
      access = store.roles.some(r => r === roles);
    }
    return access;
  }

  public static hasMultipleRoles(roles: SecUtilHasRoles): boolean {
    const store = useStore();
    let access = false;
    if (roles.or !== undefined) {
      let orAccess = false;
      roles.or.forEach((role: string) => {
        if (store.roles.some(r => r === role)) {
          orAccess = true;
        }
      });
      access = orAccess;
    } else if (roles.and !== undefined) {
      let andAccess = true;
      roles.and.forEach((role: string) => {
        if (!store.roles.some(r => r === role)) {
          andAccess = false;
        }
      });
      access = andAccess;
    }
    return access;
  }

  public static coaching(property: CoachingModule): boolean {
    const store = useStore();
    return store.coaching[property];
  }

  public static sanitize(text: string | undefined) {
    if (text === undefined) {
      return '';
    }
    return DOMPurify.sanitize(text, {USE_PROFILES: {html: true}});
  }
}
